import React, { lazy } from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CtaButton } from './CtaButton';
interface StackItem {
  label: string;
  value: string;
  img?: string;
  highlight?: boolean;
}
const items: StackItem[] = [{
  label: 'Launch Machine (8 GPTs Full System)',
  value: '$297',
  img: 'https://cdn.magicpatterns.com/uploads/eGJa3D669w1J2HjT7j2Vvt/gpt-mk.png'
}, {
  label: 'BONO 1: Mentoría Live con el Maestro',
  value: '$197',
  img: 'https://cdn.magicpatterns.com/uploads/9tiD3h7wK6A6nqr9oz7nLC/gpt-bn-2.png'
}, {
  label: 'BONO 2: El Kit de Velocidad (50 Págs)',
  value: '$47',
  img: 'https://cdn.magicpatterns.com/uploads/5bh3gaXa9BzQzd5vnMbXod/bpt-bn-1.png'
}, {
  label: 'BONO 3: Inner Circle VIP Community',
  value: '$97',
  img: 'https://cdn.magicpatterns.com/uploads/p9MrzV4DiCenR5tGSmcEwj/gpt-bn-3.png'
}, {
  label: 'REGALO EXTRA: Licencia de Reventa 50%',
  value: 'INESTIMABLE',
  highlight: true
}];
export function ValueStack() {
  return <section id="oferta" className="w-full scroll-mt-20 bg-zinc-950 py-16 sm:py-24" data-id="element-196">
      <div className="mx-auto max-w-3xl px-4" data-id="element-197">
        <Reveal data-id="element-198">
          <h2 className="text-center font-display text-2xl text-white sm:text-4xl" data-id="element-199">
            Todo lo que recibes <span className="text-orange-500" data-id="element-200">hoy</span>
          </h2>
        </Reveal>

        <Reveal delay={0.05} data-id="element-201">
          <div className="mt-10 overflow-hidden rounded-3xl border border-zinc-800 bg-black/50" data-id="element-202">
            <ul data-id="element-203">
              {items.map((item, i) => <li key={item.label} className={`flex items-center gap-4 border-b border-zinc-800/80 p-4 sm:p-5 ${item.highlight ? 'bg-amber-400/5' : ''}`} data-id="element-204">
                  {item.img ? <img src={item.img} alt={item.label} className="h-14 w-14 shrink-0 rounded-lg object-cover sm:h-16 sm:w-16" loading="lazy" data-id="element-205" /> : <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-amber-400/10 text-amber-400 sm:h-16 sm:w-16" data-id="element-206">
                      <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-207" />
                    </span>}
                  <span className="flex-1 text-sm font-medium text-zinc-200 sm:text-base" data-id="element-208">
                    {item.label}
                  </span>
                  <span className={`shrink-0 text-right text-sm font-bold sm:text-base ${item.highlight ? 'text-amber-400' : 'text-zinc-500 line-through'}`} data-id="element-209">
                    {item.highlight ? item.value : `Valor: ${item.value}`}
                  </span>
                </li>)}
            </ul>

            <div className="space-y-1 p-6 text-center sm:p-8" data-id="element-210">
              <p className="text-base text-zinc-400" data-id="element-211">
                Valor Total:{' '}
                <span className="font-bold text-zinc-500 line-through" data-id="element-212">
                  $638.00
                </span>
              </p>
              <p className="font-display text-4xl text-glow-orange text-orange-500 sm:text-5xl" data-id="element-213">
                Precio hoy: $47.00
              </p>
              <p className="text-sm font-semibold uppercase tracking-wide text-amber-400" data-id="element-214">
                Pago único
              </p>
            </div>

            <div className="px-6 pb-8 text-center sm:px-8" data-id="element-215">
              <CtaButton size="xl" className="w-full" data-id="element-216">
                Sí, quiero acceso instantáneo por $47
              </CtaButton>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}